module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-lazyload-01.88104ed7.jpg";